export enum Routes {
  ROOT = '/',
  NOT_FOUND = '/404',
}
